import React, { useEffect, useRef, useState } from "react";
import "./Navbar.css";
import logo from "../Assets/logo/aitam_logo.png";

export default function Navbar() {
  const [open, setOpen] = useState(false);
  const panelRef = useRef(null);

  useEffect(() => {
    document.body.style.overflow = open ? "hidden" : "";
    return () => { document.body.style.overflow = ""; };
  }, [open]);

  useEffect(() => {
    function onKey(e) {
      if (e.key === "Escape") setOpen(false);
    }
    window.addEventListener("keydown", onKey);
    return () => window.removeEventListener("keydown", onKey);
  }, []);

  const btnRef = useRef(null);
  useEffect(() => {
    if (!open && btnRef.current) btnRef.current.focus();
  }, [open]);

  const links = [
    // { href: "#Hero", label: "Home" },
    { href: "#about", label: "About" },
    { href: "#timeline", label: "Timeline" },
    { href: "#prizes", label: "Prizes" },
    { href: "#tests", label: "Tests" },
    { href: "#gallery", label: "Gallery" },
    { href: "#partners", label: "Partners" },
    { href: "#Footer", label: "Contact Us" },
    // { href: "https://docs.google.com/forms/d/e/1FAIpQLScZnKBW10oTRiaRK-kyb5OuCh94Zm4mnwII7zRU_lGMmDqQYA/viewform", label: "Rule Book" },
  ];

  return (
    <>
      <header className="nav">
        <div className="container nav-inner">

          {/* LOGO + TITLE WRAPPER */}
          <div className="logo-container">
            <img src={logo} alt="AITAM Logo" className="aitam-logo" />
            {/* <div className="logo">AITAM's GoKarting Championship</div> */}
          </div>

          <nav className="menu" aria-label="Primary">
            {links.map((l) => (
              <a key={l.href} href={l.href}>{l.label}</a>
            ))}
             <div className="rule">
            <a href="https://drive.google.com/drive/folders/1pMJIOMPz0dr1__CRXZ5oaRm1ZoAKipi0?usp=drive_link" 
                     target="_blank" 
                     rel="noopener noreferrer" 
                     className="btnr rule">
                     Rule Book
            </a>
          </div>
          </nav>
         

          <button
            ref={btnRef}
            className="hamburger"
            aria-label={open ? "Close menu" : "Open menu"}
            aria-expanded={open}
            onClick={() => setOpen((s) => !s)}
          >
            {open ? "✕" : "☰"}
          </button>
        </div>
      </header>

      {/* BACKDROP */}
      <div
        className={`panel-backdrop ${open ? "open" : ""}`}
        onClick={() => setOpen(false)}
      />

      {/* MOBILE PANEL */}
      <aside
        ref={panelRef}
        className={`mobile-panel ${open ? "open" : ""}`}
      >
        <div className="panel-header">
          <div className="logo">AITAM's GoKart Championship</div>
          <button className="panel-close" onClick={() => setOpen(false)}>
            ✕
          </button>
        </div>

        <nav className="panel-menu">
          {links.map((l) => (
            <a key={l.href} href={l.href} onClick={() => setOpen(false)}>
              {l.label}
            </a>
          ))}
             <div className="rule">
            <a href="https://drive.google.com/drive/folders/1pMJIOMPz0dr1__CRXZ5oaRm1ZoAKipi0?usp=drive_link" 
                     target="_blank" 
                     rel="noopener noreferrer" 
                     className="btnr rule">
                     Rule Book
            </a>
          </div>
        </nav>

        <div className="panel-footer">
          <small>© {new Date().getFullYear()} AITAM'S GoKart Championship</small>
        </div>
      </aside>
    </>
  );
}
